import React, { useEffect } from "react";
import { ContentSection } from "sprint-common-web";

import { CloudFileFilePreviewErrorBoundary } from "../CloudFilePreviewErrorBoundary";
import { useVideoFilePreviewSection } from "./hooks/useVideoFilePreviewSection";
import { VideoFilePreview } from "./VideoFilePreview";

interface VideoFilePreviewSectionProps {
    minHeight: number;
}

export const VideoFilePreviewSection = ({ minHeight }: VideoFilePreviewSectionProps): JSX.Element => {
    const {
        filePreview,
        lastLoadedVersionIds,
        setLastLoadedVersionIds,
        cloudFileDetails,
        isLoading,
        reloadPreview,
        selectedVersionInfo
    } = useVideoFilePreviewSection();

    useEffect(() => {
        if (!filePreview && cloudFileDetails?.cloudFileId) {
            reloadPreview({
                cloudFileId: cloudFileDetails.cloudFileId
            });
        }
    }, [cloudFileDetails?.cloudFileId, filePreview]);

    useEffect(() => {
        const hasVersionIds = selectedVersionInfo?.versionIds.length;
        const canLoadExisting = hasVersionIds && filePreview && cloudFileDetails?.cloudFileId;

        if (canLoadExisting) {
            const currentVersionIds = selectedVersionInfo?.versionIds.join(",");

            if (currentVersionIds !== lastLoadedVersionIds) {
                setLastLoadedVersionIds(currentVersionIds);
                reloadPreview({
                    cloudFileId: cloudFileDetails.cloudFileId,
                    versionIds: selectedVersionInfo?.versionIds
                });
            }
        } else if (!hasVersionIds && lastLoadedVersionIds) {
            setLastLoadedVersionIds(undefined);
        }
    }, [selectedVersionInfo, filePreview, cloudFileDetails?.cloudFileId, lastLoadedVersionIds]);

    return (
        <ContentSection
            header="Preview"
            isLoading={isLoading}
            style={{ minHeight }}
            testId="video-file-preview-section"
        >
            <CloudFileFilePreviewErrorBoundary>
                <VideoFilePreview />
            </CloudFileFilePreviewErrorBoundary>
        </ContentSection>
    );
};
